import React, { ChangeEvent } from 'react';
import cn from 'classnames';
import styles from './TextAreaStyles.module.css';

interface TextAreaProps {
  id?: string;
  name: string;
  placeholder?: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string;
  className?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  id,
  name,
  placeholder,
  onChange,
  value,
  className,
}) => (
    <textarea
      id={id}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      className={cn('form-control', styles.textArea, className)}
    />
  );

export default TextArea;
